export default {
  singleLabel: "Popup",
  storeNamespace: 'popup',
  authFeature: 'popup',
  listRouteName: null,
  newRouteName: null,
  editRouteName: "PopupEdit",
  fields: [{
      name: 'text',
      label: "Texte",
      type: 'textarea',
      inForm: true,
    },
    {
      name: 'stored_file',
      label: "Image",
      type: 'file',
      inForm: true,
    },
    {
      name: 'start_date',
      label: "Date du début de l'affichage",
      type: 'date',
      inForm: true,
      required: true,
    },
    {
      name: 'end_date',
      label: "Date de fin de l'affichage",
      type: 'date',
      inForm: true,
      required: true,
    },
  ]
}



// WEBPACK FOOTER //
// ./src/components/Popup/config.js